import {wayOfBuyingOptions} from '../components/_helpers';
import {isLabelValue} from './checkObjects';
import {WaysOfBuying} from '../models/WaysOfBuying';
import {EMPTY_LABEL_VALUE} from './constants';

export const extractValuesFromWayOfBuyingOptions = (wayOfBuyingOptions) => wayOfBuyingOptions.map((item) => item.value);

/**
 * Format waysOfBuying for converting
 * @param {string[]|undefined} waysOfBuyingResponse
 * @return {{currentValue: LabelValue, availableOptions: string[]}}
 */
export const formatWaysOfBuying = (waysOfBuyingResponse) => {
    if (waysOfBuyingResponse === undefined || waysOfBuyingResponse.length === 0) {
        return {
            currentValue: wayOfBuyingOptions[0],
            availableOptions: extractValuesFromWayOfBuyingOptions(wayOfBuyingOptions),
        };
    }

    if (waysOfBuyingResponse.length === 1) {
        return {
            currentValue: wayOfBuyingOptions.find((item) => item.value === waysOfBuyingResponse[0]),
            availableOptions: waysOfBuyingResponse,
        };
    }

    if (waysOfBuyingResponse.length > 1) {
        return {
            currentValue: {
                label: '',
                value: '',
            },
            availableOptions: waysOfBuyingResponse,
        };
    }
};

/**
 * Format waysOfBuying for converting
 * @param {string | undefined} waysOfBuyingResponse
 * @return {{currentValue: LabelValue, availableOptions: string[]}}
 */
export const formatWaysOfBuyingByLabel = (waysOfBuyingResponse) => {
    if (!waysOfBuyingResponse) {
        return {
            currentValue: wayOfBuyingOptions[0],
            availableOptions: extractValuesFromWayOfBuyingOptions(wayOfBuyingOptions),
        };
    } else {
        const normalizedResponse = waysOfBuyingResponse.toLowerCase().trim();
        const matchedOption = wayOfBuyingOptions.find((item) =>
            item.label.toLowerCase().trim() === normalizedResponse,
        );
        return {
            currentValue: matchedOption || EMPTY_LABEL_VALUE,
            availableOptions: extractValuesFromWayOfBuyingOptions(wayOfBuyingOptions),
        };
    }
};


/**
 * This function will take the old Way of Buying and transform them into the new format
 * @param {LabelValue|{currentValue: LabelValue, availableOptions: string[]}} wob
 * @return {WaysOfBuying}
 */
export const convertOldWoB = (wob) => {
    // Old way of buying was a simple LabelValue object
    if (isLabelValue(wob)) {
        return new WaysOfBuying(
            wob,
            extractValuesFromWayOfBuyingOptions(wayOfBuyingOptions),
        );
    } else {
        return new WaysOfBuying(
            wob.currentValue,
            wob.availableOptions,
        );
    }
};

/**
 * Finds the LabelValue object for a given label or value.
 * @param {string} input
 * @return {LabelValue|null}
 */
export const getWayOfBuyingLabelValue = (input) => {
    const normalizedInput = input.toLowerCase().trim();
    const result = wayOfBuyingOptions.find((option) =>
        option.label.toLowerCase().trim() === normalizedInput ||
        option.value.toLowerCase().trim() === normalizedInput,
    ) || null;
    return result;
};


/**
 * Converts PSL wayOfBuying values to LabelValue.
 * @param {string[]} wayOfBuyingArray
 * @return {LabelValue|null}
 */
export const mapPSLWayOfBuying = (wayOfBuyingArray) => {
    if (Array.isArray(wayOfBuyingArray) && wayOfBuyingArray.length > 0) {
        const value = wayOfBuyingArray[0];
        return getWayOfBuyingLabelValue(value);
    }
    return null;
};

